import { Component, OnInit } from '@angular/core';
import { DAO } from '../../modal/DAO';
import { ServiceLayer } from '../../services/serviceLayer';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css']
})
export class SearchResultsComponent implements OnInit {

  constructor(private serviceLayer: ServiceLayer, public dao: DAO) { }
  public policiesList = []
  public suggestpolicies = [];
  public initialPoliciesList: any = []
  public policyNumberModal: any;
  public statusDropdownList: any = [];
  public statusModal: any = 'Active';
  ngOnInit(): void {
    this.initialPoliciesList=this.getPolicies();
  }
  //======get policies based on loged in user mail id=============
  async getPolicies() {
    this.policiesList = await this.serviceLayer.getSearchPoliciesList('Policy');
    this.statusDropdownList = await this.serviceLayer.getStatusList();
    // this.getPolicyBasedOnNumber(null);
    return this.policiesList;
  }
  //==============load policy number into auto complete box===========
  async getPolicyBasedOnNumber(event) {
    this.suggestpolicies = [];
    this.suggestpolicies=await this.serviceLayer.getThePolicyNumber(this.initialPoliciesList,event);

  }
  //============get policy based on status=========
  async getPolicyBasedOnFilter() {
    const searchFileter={ SearchValue: this.policyNumberModal, Status: (this.statusModal.value ?  this.statusModal.value : '')}
    return this.policiesList = await this.serviceLayer.getSearchPoliciesList('Policy',searchFileter );
  }
  //=============get color code based on status============
  getColorCode(status) {
    return this.serviceLayer.getColorCode(status)
  }
  //=======serach button click========
  async searchPolicyDetails(){
    if(this.policyNumberModal==''){
      this.policiesList = await this.serviceLayer.getSearchPoliciesList('Policy');
    }
  }
  //=============export excel================
  async exportExcel(data: any) {
    let exportColumns=[
      {lable:"Policy Number",fields:'policyNumber'},
      {lable:"Name Insured",fields:'nameInsured'},
      // {lable:"Effective Date",fields:'effectiveDate',rule:"this.datepipe.transform(new Date({0}), 'MM/dd/yyyy') "},
      // {lable:"Expire Date",fields:'expireDate',rule:"this.datepipe.transform(new Date({0}), 'MM/dd/yyyy') "},
      {lable:"Effective Date",fields:'effectiveDate'},
      {lable:"Expire Date",fields:'expireDate'},
      {lable:"Line of Business",fields:'lineOfBusinuss'},
      {lable:"Jobsite Address",fields:'jobSiteAddress'},
      {lable:"Status",fields:'status'}
    ];
    await this.serviceLayer.exportExcel(data.value,exportColumns,'policiesDetail');
  }
}
